import React from "react";
import PropTypes from "prop-types";
import styled from 'styled-components';

import EmojiStronglyDisagree from "../../containers/assets/emoji-strongly-disagree.svg";
import EmojiDisagree from "../../containers/assets/emoji-disagree.svg";
import EmojiNeutral from "../../containers/assets/emoji-neutral.svg";
import EmojiAgree from "../../containers/assets/emoji-agree.svg";
import EmojiStronglyAgree from "../../containers/assets/emoji-strongly-agree.svg";

const Emojies = [
  EmojiStronglyDisagree,
  EmojiDisagree,
  EmojiNeutral,
  EmojiAgree,
  EmojiStronglyAgree,
];

const Wrapper = styled.div`
  display: block;
  position: relative;
`;

const EmojiGrayscaled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  position: absolute;

  img {
    width: 36px;
    height: 36px;
    filter: grayscale(1);
  }
`;

const Emoji = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow: hidden;
  position: relative;
  z-index: 1;

  img {
    width: 36px;
    height: 36px;
  }
`;

const calculateWidth = value => Math.round(value / 5 * 10000) / 100;

const Rating = ({ value }) => (
  <Wrapper>
    <EmojiGrayscaled>
      {Emojies.map((emoji, index) => (
        <img
          key={`rating-emoji-${index}`}
          src={emoji}
          alt="emoji"
        />
      ))}
    </EmojiGrayscaled>
    <Emoji style={{ width: `${calculateWidth(value)}%` }}>
      {Emojies.map((emoji, index) => (
        <img
          key={`rating-emoji-${index}`}
          src={emoji}
          alt="emoji"
        />
      ))}
    </Emoji>
  </Wrapper>
);

Rating.propTypes = {
  value: PropTypes.number,
};

export default Rating;



// WEBPACK FOOTER //
// ./src/components/rating/index.js